import React from 'react';

const STATUS_LABELS = {
  draft: 'Rascunho',
  em_producao: 'Em Producao',
  aprovado: 'Aprovado',
  publicado: 'Publicado',
};

function PostStatusBadge({ status }) {
  return (
    <span className={`status-badge status-badge--${status}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export default PostStatusBadge;
